export default "__VITE_ASSET__ClJD_ZIg__"